import { render } from "./SchedulerDocumentAccordion.vue?vue&type=template&id=2fd3d4ed&scoped=true&ts=true"
import script from "./SchedulerDocumentAccordion.vue?vue&type=script&lang=ts"
export * from "./SchedulerDocumentAccordion.vue?vue&type=script&lang=ts"

import "./SchedulerDocumentAccordion.vue?vue&type=style&index=0&id=2fd3d4ed&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd3d4ed"]])

export default __exports__